module.exports = __webpack_public_path__ + "img/military_base-hotspot-1.1.715d0968.png";